import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { registerAbayNavigate } from "@/lib/abayAiBus";

// Registers the router navigate() with the Abay AI bus so openAbayAI()/askAbayAI()
// can route to the unified /abay-ai experience from anywhere in the app.
// Renders nothing.
export default function AbayAIBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    registerAbayNavigate(navigate);
    return () => registerAbayNavigate(null);
  }, [navigate]);
  return null;
}
